<div class="text-center" *ngIf="dataLoading">
    <ap-spinner size="3"></ap-spinner>
</div>

<form [formGroup]="resultsSearchFormGroup" (ngSubmit)="getResults()" #form="ngForm">
    <div class="row">
        <div class="col-xs-12 col-md-6">
            <div class="form-group">
                <label class="active" for="startdate" translate>Start Date</label>
                    <ap-date-picker
                      [baseId]="'search-date-start'"
                      [required]="false"
                      formControlName="startDateControl"
                      [labelName]="'start date'"
                      [showLabel]="false"
                      [maxDate]="selectedStartDate"
                      (ngModelChange)="onStartDateChanged($event)">
                    </ap-date-picker>
            </div>
        </div>
        <div class="col-xs-12 col-md-6">
            <div class="form-group">
                <label class="active" for="enddate" translate>End Date</label>
                    <ap-date-picker
                      [baseId]="'search-date-end'"
                      [required]="false"
                      formControlName="endDateControl"
                      [labelName]="'end date'"
                      [showLabel]="false"
                      [minDate]="selectedEndDate"
                      (ngModelChange)="onEndDateChanged($event)">
                    </ap-date-picker>
            </div>
            <button id="searchButton" type="submit" [disabled]="dataLoading"
                      class="btn btn-primary pull-right" translate>
                      Search
            </button>
        </div>
    </div>
</form>
<div class="search-results" *ngIf="!dataLoading">
    <table id="example" class="table emds-table table-sticky-header table-striped table-border-top table-flush-top"
        cellspacing="0" width="100%">
        <thead>
            <tr>
                <th translate>Order Date</th>
                <th translate>Description</th>
                <th translate>Result Date</th>
                <th translate>Results</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let result of searchResults">
                <td>{{result.OrderDate | date: 'M/d/yyyy'}}</td>
                <td>{{result.Description}}</td>
                <td>{{result.ResultDate | date: 'M/d/yyyy'}} </td>
                <td><a (click)="clickedViewResults(result)"><u>View Results</u></a></td>
            </tr>
        </tbody>
    </table>
    <div [hidden]="searchResults?.length || dataLoading" translate>
        No results found.
    </div>
</div>